import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  Spacer,
  Text,
  useDisclosure,
  Tabs,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import { CodingHistoryModal } from "../history/CodingHistoryModal";
import { t } from "i18next";
import { CodingView } from "../../../../../coding/models/CodingView";
import { useStores } from "../../../../../shared/stores/RootStore";

const CodingHeaderBase: React.FC = () => {
  const [showSavedChanges, setShowSavedChanges] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const codingHistoryModal = useDisclosure();
  const { codingStore, osaWayStore } = useStores();

  const way = osaWayStore.getSelected()!;

  /**
   * Control "changes saved" message time and load node score after changes saved.
   */
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    } else if (codingStore.changesSaved && !codingStore.savingChanges) {
      setShowSavedChanges(true);
      setTimeout(() => {
        setShowSavedChanges(false);
      }, 3000);
    }
    //eslint-disable-next-line
  }, [codingStore.changesSaved, codingStore.savingChanges]);

  const saveChanges = () => {
    codingStore.saveChanges();
  };

  return (
    <>
      <HStack gap={6} px={6} alignItems="center">
        <Tabs.Root
          alignSelf={"end"}
          colorPalette={"primary"}
          fontSize={"sm"}
          value={codingStore.view}
          onValueChange={(e) => codingStore.setView(e.value as CodingView.Enum)}
        >
          <Tabs.List borderBottomWidth={"0px"}>
            {Object.values(CodingView.Enum).map((view) => (
              <Tabs.Trigger key={view} value={view}>
                {CodingView.getLabel(view)}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
        </Tabs.Root>

        <Text fontSize="sm">
          {`${way.stats!.nNodesCoded}/${way.stats!.nNodes} ${t(
            "coding:common.nodesCoded",
          )}`}
        </Text>

        <Spacer />

        {showSavedChanges && !codingStore.savingChanges && (
          <Box fontSize="xs">{t("coding:common.saved")}</Box>
        )}
        {codingStore.savingChanges && (
          <Box fontSize="xs">{t("coding:common.saving")}</Box>
        )}

        <ButtonGroup
          colorPalette="primary"
          size="sm"
          variant="ghost"
          fontSize={"sm"}
        >
          <Button
            onClick={saveChanges}
            disabled={codingStore.changesSaved}
            loading={codingStore.savingChanges}
          >
            {t("coding:common.save")}
          </Button>

          <Button onClick={codingHistoryModal.onOpen}>Undo...</Button>
        </ButtonGroup>
      </HStack>

      {codingHistoryModal.open && (
        <CodingHistoryModal onClose={codingHistoryModal.onClose} />
      )}
    </>
  );
};

export const CodingHeader = observer(CodingHeaderBase);